class StandardQuestion {
    dataField: string;
    label: string;
    required: boolean;
    hidden: boolean;
    sensitive: boolean;
    type: string;
    readonly: boolean;
    minLength: number | null;
    tab: string;
    category: string;
    
    constructor()
    {
        this.dataField = "";
        this.label = "";
        this.required = false;
        this.hidden = false;
        this.sensitive = false;
        this.type = "";
        this.readonly = false;
        this.minLength = null;
        this.tab = "";
        this.category = "";
    }
}

export default StandardQuestion;